import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import type { DialogProps } from '@/dialogs/types'
import { $creatorId } from '@/models/creators.ts'
import { useListMutations } from '@/modules/tiktok-research/hooks/useListMutations.ts'
import type { TikTokContentListType } from '@/modules/tiktok-research/videos/ui/types'
import { AppRoutes } from '@/utils/constants'

interface Props extends DialogProps {
  list?: TikTokContentListType
}

export const DeleteTikTokListDialog = ({ isOpen, onClose, list }: Props) => {
  const { deleteList } = useListMutations()
  const creatorId = useUnit($creatorId)
  const navigate = useNavigate()

  const handleDeleteList = async () => {
    if (!creatorId || !list) {
      return
    }
    await deleteList.mutateAsync(list.id)

    onClose()
    navigate(AppRoutes.TiktokResearch.Lists.Index.asUrl(creatorId))
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      bigDialog
    >
      <Dialog.Header className="mb-2">
        <Dialog.Title>Delete List</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="block text-center">
        Are you sure you want to delete this list?
      </Dialog.Description>
      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          variant="destructive"
          onClick={handleDeleteList}
          isLoading={deleteList.isLoading}
        >
          Delete
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
